import { Search } from "react-feather";
import { Button, CardBody, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import PaginationComponent from "../Common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { fetchSubMaterial } from "Features/Learning/SubMateri/Utils/SubMateriUtils";
import { handleBackPagination, handleClickPagination, handleNextPagination } from "Features/Learning/SubMateri/Utils/SubMateriUtils";
import { setFilters } from "Features/Learning/SubMateri/subMaterialSlice";
import { setField } from 'Features/Learning/Materi/addMaterialSlice';
import Swal from "sweetalert2";

const ModalAddSubMateri = ({ handleOpenSubMateri, openSubMateri, selectedValue, setSelectedValue, handleSelectChange }) => {
  const [dataSubMateri, setDataSubMateri] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [refatch, setRefatch] = useState(false);
  const [search, setSearch] = useState('');
  const filters = useSelector(state => state.subMaterial.filters)
  const isLoading = useSelector(state => state.subMaterial.isLoading)
  const pagination = useSelector((state) => state.subMaterial.data.pagination);
  const data = useSelector(state => state.addMaterial)
  const dispatch = useDispatch();
  const [isSelectAll, setIsSelectAll] = useState(false);

  // toggle modal with confirmation when there are changes compared to initial items (data.subMaterials)
  const toggleModal = async () => {
    const items = Array.isArray(data?.subMaterials) ? data.subMaterials : [];
    const initialIds = (items || []).map((i) => i.id).sort().join(",");
    const currentIds = (selectedIds || []).slice().sort().join(",");

    if (openSubMateri) {
      // modal is open -> closing
      if (initialIds !== currentIds) {
        const result = await Swal.fire({
          title: "Apakah anda yakin?",
          text: "Perubahan yang belum disimpan akan dibatalkan.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ya",
          cancelButtonColor: "#d33",
        });
        if (!result.isConfirmed) return;
      }

      // restore to initial items and ids, then close modal
      setSelectedValue(items?.length > 0 ? items : []);
      setSelectedIds(items?.length > 0 ? items.map((it) => it.id) : []);
      handleOpenSubMateri();
      return;
    }

    // opening modal: initialize selected from current items and open modal
    setSelectedValue(items?.length > 0 ? items : []);
    setSelectedIds(items?.length > 0 ? items.map((it) => it.id) : []);
    handleOpenSubMateri();
  };

  useEffect(() => {
    dispatch(fetchSubMaterial({
      ...filters,
      'sort': 'name',
    }))
      .then((response) => {
        setDataSubMateri(response?.payload?.data)
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, [dispatch, filters, refatch])

  useEffect(() => {
    dataSubMateri.every(item => selectedIds.includes(item.id)) ? setIsSelectAll(true) : setIsSelectAll(false)
  }, [selectedIds, dataSubMateri])

  useEffect(() => {
    if (selectedValue.length > 0) {
      setSelectedIds(selectedValue.map(item => item.id));
    }
  }, [selectedValue])

  const handleClickSearch = () => {
    setRefatch(!refatch);
  };

  const updateSearchParams = useCallback(() => {
    dispatch(
      setFilters({
        ...filters,
        "filter[name]": search,
        "page": 1
      })
    );
  }, [search]);

  useEffect(() => {
    const delay = setTimeout(updateSearchParams, 500);

    return () => clearTimeout(delay);
  }, [search]);

  const handleSelectAll = () => {
    if (isSelectAll) {
      const newSelectedValue = selectedValue.filter((value) => !dataSubMateri.some((item) => item.id === value.id));
      const newSelectedIds = selectedIds.filter((id) => !dataSubMateri.some((item) => item.id === id));
      setSelectedValue(newSelectedValue);
      setSelectedIds(newSelectedIds);
    } else {
      const newSelectedValue = dataSubMateri.filter((item) => !selectedValue.some((value) => value.id === item.id));
      const newSelectedIds = dataSubMateri.map((item) => item.id).filter((id) => !selectedIds.includes(id));
      setSelectedValue([...selectedValue, ...newSelectedValue]);
      setSelectedIds([...selectedIds, ...newSelectedIds]);
    }
  };

  const handleCheckboxChange = (item) => {
    if (selectedIds.includes(item.id)) {
      const newSelectedValue = selectedValue.filter((value) => value.id !== item.id);
      const newSelectedIds = selectedIds.filter((id) => id !== item.id);
      setSelectedValue(newSelectedValue);
      setSelectedIds(newSelectedIds);
    } else {
      setSelectedValue([...selectedValue, item]);
      setSelectedIds([...selectedIds, item.id]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault()
    const newSelectedValue = selectedValue.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.id === value.id
      ))
    );
    dispatch(setField({ field: 'subMaterials', value: newSelectedValue }));
    handleSelectChange(newSelectedValue)
    handleOpenSubMateri(false)
  }

  return (
    <Modal isOpen={openSubMateri} size="lg" toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>
        Tambahkan Sub Materi ke Materi
      </ModalHeader>
      <ModalBody>
        <ul>
          {selectedValue.length > 0 &&
            selectedValue.map((item, index) => (
              <li key={`item-${index}`}>
                {item.id} - {item.name}
              </li>
            ))}
        </ul>
        <div className="faq-form mt-3">
          <Input
            className="form-control"
            type="text"
            placeholder="Search.."
            value={search}
            onKeyUp={(e) => (e.key === "Enter" ? handleClickSearch(e) : null)}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="search-icon" />
        </div>
        <Table className="table-responsive table-bordered my-3">
          <thead className="table-light">
            <tr>
              <th scope="col">{"#"}</th>
              <th scope="col">{"ID"}</th>
              <th scope="col">Nama Sub Materi</th>
              <th scope="col" className="text-center" colSpan="2">
                <Input
                  className="checkbox_animated"
                  id={`selectAll`}
                  type="checkbox"
                  checked={selectedIds.length > 0 && isSelectAll}
                  onChange={handleSelectAll}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {dataSubMateri &&
              dataSubMateri.map((item, index) => (
                <tr key={`item-${index}`}>
                  <th>{pagination.from + index}</th>
                  <th>{item.id}</th>
                  <td>
                    <span
                      className="mb-0 d-block"
                      style={{ whiteSpace: 'pre-wrap' }}
                    >{item.name}</span>
                  </td>
                  <td className="text-center">
                    <Input
                      className="checkbox_animated"
                      id={`detach-${item.id}`}
                      type="checkbox"
                      checked={selectedIds.includes(item.id)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <CardBody>
          {isLoading === false && pagination && (
            <PaginationComponent
              pagination={pagination}
              handleBackPagination={() =>
                handleBackPagination(
                  pagination,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
              handleClickPagination={(page) =>
                handleClickPagination(
                  page,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
              handleNextPagination={() =>
                handleNextPagination(
                  pagination,
                  filters,
                  dispatch,
                  setFilters,
                  setRefatch
                )
              }
            />
          )}
        </CardBody>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>{" "}
      </ModalFooter>
    </Modal>
  )
}

export default ModalAddSubMateri